import React from 'react';

export default function AdminLayout({ children }) {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      {children}
    </div>
  );
}
